module.exports = __webpack_public_path__ + "img/photo.ae5cefde.jpg";